module.exports = __webpack_public_path__ + "img/ibn-alhaythem-mini.7ee38f25.png";